import { motion } from "framer-motion"
import { Button } from "./Button"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next";

export const HomeDescription = () => {
    const { t, } = useTranslation();

    const images = [
        { source: "/assets/leuven/img1.webp", title: "Leuven train station" },
        { source: "/assets/leuven/img2.webp", title: "Leuven Ladeuzeplein" },
        { source: "/assets/leuven/img3.webp", title: "Leuven Sint-Donatus Park" },
        { source: "/assets/leuven/img4.webp", title: "Leuven Dyle river" },
        { source: "/assets/leuven/img5.webp", title: "Klein Begijnhof Leuven" },
        { source: "/assets/leuven/img6.webp", title: "Leuven Bondgenotenlaan" },
    ];

    return (
        <motion.div
            className="flex flex-col gap-4 p-4 text-lg justify-center items-center mx-auto"
            initial={{ opacity: 1, y: 200 }}
            whileInView={{
                opacity: 1,
                y: 0,
                transition: { delay: 0, duration: 0.9 },
            }}
            viewport={{ once: true, amount: 0 }}>
            <div className="max-w-screen-xl flex flex-col max-lg:mt-36 max-sm:mt-0 gap-4">
                <h2 className="uppercase text-2xl text-center font-bold text-3xl">
                    {t("homePage.body.title.prefix")} <span className="text-textColor">{t("homePage.body.title.highlight")}</span>
                </h2>

                <h3>
                    {t("homePage.body.description.top")}
                </h3>

                <ul className="list-disc">
                    {t("homePage.body.description.points", { returnObjects: true }).map((point, index) => (
                        <li key={index} className="mb-2 ml-8">
                            {point}
                        </li>))}
                </ul>

                <h3>
                    {t("homePage.body.description.bottom")}
                </h3>
            </div>
            <Link to="/about">
                <Button text={t("homePage.body.detailsAboutUs")} />
            </Link>

            <div className="grid grid-cols-6 max-sm:grid-cols-2 max-lg:grid-cols-3 gap-4">
                {
                    images.map((image, index) => {
                        return (
                            <img key={index} className="rounded-md w-[300px] h-[250px]" src={image.source} alt="" title={image.title} loading="eager" width="300" height="250" />
                        )
                    })
                }
            </div>
        </motion.div>
    )
}
